var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState } from "react";
import "../../stylesheets/components/Generic/GenericDropdownFilter.scss";
import { GenericFilter } from "@frameworks/shared-library/components/Generic/FilterSidebar/GenericFilterSidebar";
import { EDataSource, } from "@domains/salesFeatures/Common/entities/IFilterDataEntity";
import filterDi from "@frameworks/salesjourney/components/filterDi/serviceLocator";
import { useSelector } from "react-redux";
function GenericDropdownFilter(props) {
    var _a = __read(React.useState(false), 2), openFilter = _a[0], setOpenFilter = _a[1];
    var _b = __read(React.useState([]), 2), filterList = _b[0], setFilterList = _b[1];
    var filterRef = React.useRef(null);
    var _c = __read(useState(false), 2), firstapiCall = _c[0], setfirstapiCall = _c[1];
    var _d = __read(useState([]), 2), localRetainedFilters = _d[0], setLocalRetainedFilters = _d[1];
    var retainedNRProductList = useSelector(function (state) { return state.Common.filterDataReducer.nrProductList; });
    var getFilterData = function (dataSource, productId, selectAll, subproductId) {
        var finalFilterState = {
            dataSource: dataSource,
            productId: productId ? [productId] : [],
            subproductId: subproductId ? subproductId : [],
        };
        return filterDi.filter.getFilterDataActions({
            filterData: finalFilterState,
            page: "0",
            pageSize: "100",
        });
    };
    var getProductList = function () {
        if (!firstapiCall && !openFilter) {
            getFilterData(EDataSource.PRODUCT).then(function (dropDownlist) {
                var _a, _b;
                if (((_a = dropDownlist === null || dropDownlist === void 0 ? void 0 : dropDownlist.filterData) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    var updateFilter = (_b = dropDownlist === null || dropDownlist === void 0 ? void 0 : dropDownlist.filterData) === null || _b === void 0 ? void 0 : _b.map(function (product) {
                        var _a, _b;
                        return {
                            id: product.id,
                            checked: (retainedNRProductList === null || retainedNRProductList === void 0 ? void 0 : retainedNRProductList.length)
                                ? (_b = (_a = retainedNRProductList === null || retainedNRProductList === void 0 ? void 0 : retainedNRProductList.find(function (retainedProduct) { return retainedProduct.id === product.id; })) === null || _a === void 0 ? void 0 : _a.checked) !== null && _b !== void 0 ? _b : false
                                : false,
                            name: product.name,
                            subList: [],
                        };
                    });
                    setFilterList(updateFilter);
                    setfirstapiCall(true);
                }
                else {
                    setFilterList([]);
                }
            });
        }
    };
    var onClear = function () {
        props.setFilterList({});
        var productListForPersist = filterList.map(function (product) { return (__assign(__assign({}, product), { checked: false, subList: product.subList.map(function (subProduct) { return (__assign(__assign({}, subProduct), { checked: false })); }) })); });
        setFilterList(productListForPersist);
        filterDi.filter.updateNRProductList([]);
    };
    var onSubmit = function () {
        var productList = { productId: [], subproductId: [] };
        var productListForPersist = filterList.filter(function (product) {
            if (product.checked) {
                productList.productId = __spreadArray(__spreadArray([], __read(productList.productId), false), [
                    product.id.toString(),
                ], false);
                product.subList = product.subList.filter(function (subProduct) {
                    if (subProduct.checked) {
                        productList.subproductId = __spreadArray(__spreadArray([], __read(productList.subproductId), false), [
                            subProduct.id.toString(),
                        ], false);
                        return subProduct;
                    }
                });
                return product;
            }
        });
        filterDi.filter.updateNRProductList(productListForPersist);
        // let uniqueSet = new Set();
        // let updateList = filterList?.map((filter) => {
        //   return filter?.subList.map((product) => {
        //     if (product?.checked) {
        //       if (!uniqueSet.has(filter?.id?.toString())) {
        //         uniqueSet.add(filter?.id?.toString());
        //         productList?.productId.push(filter?.id?.toString());
        //       }
        //       productList?.subproductId.push(product?.id?.toString());
        //     }
        //   });
        // });
        props.setFilterList(productList);
    };
    var handleClickOutside = function (e) {
        if ((filterRef === null || filterRef === void 0 ? void 0 : filterRef.current) && !filterRef.current.contains(e.target)) {
            setOpenFilter(false);
        }
    };
    React.useEffect(function () {
        window.addEventListener("mousedown", handleClickOutside);
        return function () { return window.removeEventListener("click", handleClickOutside); };
    }, []);
    return (React.createElement("div", { className: "d-flex search-sort-filter", ref: filterRef },
        React.createElement("div", { className: "filter common-EdButtonIcon-icon" },
            React.createElement("div", { className: " DMSan_14_500 txt-midnight-blue generic-dropdown-filter ".concat((props === null || props === void 0 ? void 0 : props.defaultValueClass) ? props.defaultValueClass : ""), onClick: function () {
                    getProductList();
                    setOpenFilter(!openFilter);
                } },
                (props === null || props === void 0 ? void 0 : props.defaultValue) ? props.defaultValue : "All Products",
                React.createElement("i", { className: "edel-icon-arrow-down ms-2" })),
            openFilter && (React.createElement(GenericFilter, { openFilter: openFilter, setOpenFilter: setOpenFilter, setFilterList: setFilterList, filterList: filterList, onSubmit: function () {
                    onSubmit();
                }, getFilterData: getFilterData, onClear: onClear, retainedNRProductList: retainedNRProductList })))));
}
export default GenericDropdownFilter;
